export const changeLanguage = {
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
};
